import base_mutations from '@/store/modules/base/mutations.js'

export default {
    ...base_mutations,
    SET_LOADED_FOR_PROJECT_ID: (state, project_id) => {
        state.loaded_for_project_id = project_id;
    },
    SET_LOADING: (state, loading) => {
        state.loading = loading;
    },
    SET_LOADED: (state, loaded) => {
        state.loaded = loaded;
    }
}